<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="productTemperatureInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-input
            [required]="true"
            type="date"
            label="Date of Potential Temperature Excursion Identification"
            placeholder="10.10.2024"
            formControlName="dateOfPotentialTemperatureExcursion"
            class="max-w-input"
        ></sag-ui-input>

        <sag-ui-select
            [required]="true"
            label="Location of Potential Temperature Excursion Identification"
            placeholder="Select Location"
            formControlName="locationOfPotentialTemperatureExcursion"
            class="max-w-input"
        >
            @for (item of temperatureExcursionLocations | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>

        <sag-ui-input
            [required]="true"
            label="Exact Location"
            placeholder=""
            formControlName="exactLocation"
            class="max-w-input"
        ></sag-ui-input>

        <sag-ui-select
            [required]="true"
            label="Potential Temperature Excursion identified by:"
            placeholder="Select Identifier"
            formControlName="temperatureExcursionIdentifiedBy"
            class="max-w-input"
        >
            @for (item of temperatureExcursionIdentifier | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>

        <sag-ui-radio-group
            label="Does Carrier Wayboll (AWB or BOL) include shipment temperature requirements?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio
                name="includesShippingTemperatureRequirements"
                formControlName="includesShippingTemperatureRequirements"
                [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio
                name="includesShippingTemperatureRequirements"
                formControlName="includesShippingTemperatureRequirements"
                [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        <sag-ui-radio-group
            label="Did the Delivery Documentation note the potential issue?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        @if(isFalse('documentationNotedIssue')) {
        <sag-ui-textarea
            [required]="true"
            label="Explain why it was not noted"
            placeholder="Explain"
            formControlName="explanationOfMissingNote"
            class="max-w-input"
        ></sag-ui-textarea>
        }

        <app-attachments-input
            label="Attach a copy of the Delivery Documentation"
            [form]="productTemperatureInternationalForm!"
            [required]="true"
            controlName="deliveryDocumentation"
        ></app-attachments-input>

        <sag-ui-radio-group
            label="Has Carrier claim been filed for potential temperature excursion?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="claimFiled" formControlName="claimFiled" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="claimFiled" formControlName="claimFiled" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>

        @if (isTrue('claimFiled')) {
        <app-attachments-input
            label="Attach a copy of the Carrier Claim"
            [form]="productTemperatureInternationalForm!"
            [required]="true"
            controlName="carrierClaimDocumentation"
        ></app-attachments-input>
        }

        <sag-ui-textarea
            [required]="true"
            label="Explain why potential temperature excursion is suspected"
            placeholder="Explain"
            formControlName="explainWhyTemperatureExcursionSuspected"
            class="max-w-input"
        ></sag-ui-textarea>

        <app-attachments-input
            label="Attach evidence of potential temperature excursion.  (Temperature tales / Data recordings)"
            [form]="productTemperatureInternationalForm!"
            [required]="true"
            controlName="temperatureExcursionEvidence"
        ></app-attachments-input>

        <div></div>
        <label class="text-sm text-shs-gray-1"
            ><span>*</span>Describe the condition of the item (select all that apply)</label
        >
        <div class="flex flex-col gap-2">
            @for (condition of itemConditions | keyvalue; track $index) {
            <sag-ui-checkbox
                [checked]="itemConditionSelected(condition.value)"
                [disabled]="productTemperatureInternationalForm?.disabled ?? false"
                (change)="toggleItemCondition(condition.value)"
                >{{ itemConditionMapping[condition.value] }}</sag-ui-checkbox
            >
            }
        </div>

        <sag-ui-input
            [required]="true"
            label="Carrier Tracking Number"
            placeholder="Enter the tracking number (e.g., 732974323)"
            formControlName="carrierTrackingNumber"
            class="max-w-input"
        ></sag-ui-input>

        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <app-attachments-input [form]="productTemperatureInternationalForm!" controlName="relatedDocuments" />
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
